const routes = {
  base: '/',
  eligibility: {
    base: '/eligibility',
    home: '/eligibility/home',
    qualifyingLifeEvent: '/eligibility/qualifying-life-event',
    moreQuestions: '/eligibility/more-questions',
    dob: '/eligibility/dob',
    effectiveStartDate: '/eligibility/effective-start-date',
  },
  subscriberInfo: {
    base: '/subscriber-info',
    home: '/subscriber-info/home',
    contactInfo: '/subscriber-info/contact-info',
    additionalContactInfo: '/subscriber-info/additional-contact-info',
    donateLifeInfo: '/subscriber-info/donate-life-info',
  },
  dependentInfo: {
    base: '/dependent-info',
    home: '/dependent-info/home'
  },
  reviewSelection: {
    base: '/review-selection',
    home: '/review-selection/home',
    legalAgreements: '/review-selection/legal-agreements',
    thankYou: '/review-selection/thankyou'
  },
}
export default routes;